import { QueryHookOptions } from '@apollo/client'

import { useTagsQuery } from '~generated/hooks'
import { TagsQuery } from '~generated/operations'
import { Exact, FindTagsInput, TagTypes } from '~generated/types'

type PresetTagsVariables = {
  type: TagTypes
  input?: Omit<FindTagsInput, 'types'>
}

type DefaultTagsVariables = {
  type: never
  input: FindTagsInput
}

type BaseOptions = QueryHookOptions<TagsQuery, DefaultTagsVariables | PresetTagsVariables>
type Options = QueryHookOptions<TagsQuery, Exact<{ input: FindTagsInput }>>

// Product line tags are launches tags. They can be set on any other entity.
// And they must be shown with all other tags.

const typesMap: Record<TagTypes, TagTypes[]> = {
  [TagTypes.ROADMAP_ITEM]: [TagTypes.ROADMAP_ITEM],
  [TagTypes.TASK]: [
    TagTypes.TASK,
    TagTypes.PRODUCT_LINE,
    TagTypes.CHANNEL, // TODO fix type of custom tags in db and remove it
  ],
  [TagTypes.RELEASE_NOTE]: [TagTypes.RELEASE_NOTE],
  [TagTypes.PRODUCT_LINE]: [TagTypes.PRODUCT_LINE],
  [TagTypes.RESEARCH_HUB_INSIGHTS]: [TagTypes.RESEARCH_HUB_INSIGHTS],
  [TagTypes.RESEARCH_HUB_TESTIMONIALS]: [TagTypes.RESEARCH_HUB_TESTIMONIALS],
  [TagTypes.RESEARCH_HUB_PERSONAS]: [TagTypes.RESEARCH_HUB_PERSONAS],
  [TagTypes.FEEDBACK_POST]: [TagTypes.FEEDBACK_POST],
  [TagTypes.ASSET]: [
    TagTypes.ASSET,
    TagTypes.CHANNEL, // TODO fix type of custom tags in db and remove it
  ],
  // FIXME don't use tags for relationships between entities !!!!
  [TagTypes.CHANNEL]: [TagTypes.CHANNEL],
  [TagTypes.LAUNCH_NAME]: [TagTypes.LAUNCH_NAME],
  [TagTypes.COMPANY]: [TagTypes.COMPANY, TagTypes.PRODUCT_LINE],
}

/*
 * Get all tags.
 */

const useTags = (baseOptions?: BaseOptions) => {
  let options: Options = baseOptions as Options

  // insert predefined tag types
  if (baseOptions?.variables?.type) {
    options = {
      ...baseOptions,
      variables: {
        input: {
          ...baseOptions.variables.input,
          types: typesMap[baseOptions.variables.type],
        },
      },
    } as Options
  }

  const { data, ...rest } = useTagsQuery(options)

  return { tags: data?.tags || [], ...rest }
}

export default useTags
